import React from 'react';
import { Badge } from 'react-bootstrap';

interface Pill {
  label: string;
  clickable?: boolean;
  action?: () => void;
  icon?: React.ReactNode;
}

interface PillListBlockProps {
  block: {
    content?: Pill[];
  };
}

const PillListBlock: React.FC<PillListBlockProps> = ({ block }) => {
  if (!block.content || !Array.isArray(block.content)) return null;

  return (
    <div className="pill-list d-flex flex-wrap gap-2">
      {block.content.map((pill, index) => (
        <Badge
          key={index}
          as={pill.clickable ? 'button' : 'span'}
          className={`pill ${pill.clickable ? 'clickable' : ''}`}
          onClick={
            pill.clickable && pill.action ? () => pill.action() : undefined
          }
        >
          {pill.icon && <span className="pill-icon">{pill.icon}</span>}
          {pill.label}
        </Badge>
      ))}
    </div>
  );
};

export default PillListBlock;
